module.exports={
  "id": "perfect-platters",
  "name": "Perfect platters",
  "badge": "Great value",
  "subtext": "Effortlessly impress guests with a gourmet platter of ready-to-serve, delicious snacks.",
  "coverImage": "https://img.peerspace.com/image/upload/v1725383524/y9bd8pzuj78n69jh5eww.jpg",
  "price": {
    "value": 20.0,
    "per_person": true,
    "starts_at": true
  },
  "menu": {
    "menu_sections": [
      {
        "id": "platters-selections",
        "title": "Select your platter(s)",
        "min_selections": 1,
        "max_selections": 6,
        "items": [
          {
            "name": "Vegetable crudité",
            "price": {
              "value": 0.0
            },
            "sizes": [
              {
                "name": "Serves up to 10",
                "price": { "value": 289.0, "per_person": false }
              },
              {
                "name": "Serves 10-20",
                "price": { "value": 445.0, "per_person": false }
              },
              {
                "name": "Serves 20-30",
                "price": { "value": 599.0, "per_person": false }
              },
              {
                "name": "Serves 30-40",
                "price": { "value": 729.0, "per_person": false }
              },
              {
                "name": "Serves 40-50",
                "price": { "value": 809.0, "per_person": false }
              },
              {
                "name": "Serves 50+",
                "price": { "value": 1185.0, "per_person": false }
              }
            ]
          },
          {
            "name": "Brunch grazing board",
            "price": {
              "value": 0.0
            },
            "sizes": [
              {
                "name": "Serves up to 10",
                "price": { "value": 289.0, "per_person": false }
              },
              {
                "name": "Serves 10-20",
                "price": { "value": 445.0, "per_person": false }
              },
              {
                "name": "Serves 20-30",
                "price": { "value": 599.0, "per_person": false }
              },
              {
                "name": "Serves 30-40",
                "price": { "value": 729.0, "per_person": false }
              },
              {
                "name": "Serves 40-50",
                "price": { "value": 809.0, "per_person": false }
              },
              {
                "name": "Serves 50+",
                "price": { "value": 1185.0, "per_person": false }
              }
            ]
          },
          {
            "name": "Charcuterie elegance",
            "price": {
              "value": 0.0
            },
            "sizes": [
              {
                "name": "Serves up to 10",
                "price": { "value": 289.0, "per_person": false }
              },
              {
                "name": "Serves 10-20",
                "price": { "value": 445.0, "per_person": false }
              },
              {
                "name": "Serves 20-30",
                "price": { "value": 599.0, "per_person": false }
              },
              {
                "name": "Serves 30-40",
                "price": { "value": 729.0, "per_person": false }
              },
              {
                "name": "Serves 40-50",
                "price": { "value": 809.0, "per_person": false }
              },
              {
                "name": "Serves 50+",
                "price": { "value": 1185.0, "per_person": false }
              }
            ]
          },
          {
            "name": "Elaborate dessert",
            "price": { "value": 0.0 },
            "sizes": [
              {
                "name": "Serves up to 10",
                "price": { "value": 289.0, "per_person": false }
              },
              {
                "name": "Serves 10-20",
                "price": { "value": 445.0, "per_person": false }
              },
              {
                "name": "Serves 20-30",
                "price": { "value": 599.0, "per_person": false }
              },
              {
                "name": "Serves 30-40",
                "price": { "value": 729.0, "per_person": false }
              },
              {
                "name": "Serves 40-50",
                "price": { "value": 809.0, "per_person": false }
              },
              {
                "name": "Serves 50+",
                "price": { "value": 1185.0, "per_person": false }
              }
            ]
          },
          {
            "name": "Fresh seasonal fruits",
            "price": { "value": 0.0 },
            "sizes": [
              {
                "name": "Serves up to 10",
                "price": { "value": 289.0, "per_person": false }
              },
              {
                "name": "Serves 10-20",
                "price": { "value": 445.0, "per_person": false }
              },
              {
                "name": "Serves 20-30",
                "price": { "value": 599.0, "per_person": false }
              },
              {
                "name": "Serves 30-40",
                "price": { "value": 729.0, "per_person": false }
              },
              {
                "name": "Serves 40-50",
                "price": { "value": 809.0, "per_person": false }
              },
              {
                "name": "Serves 50+",
                "price": { "value": 1185.0, "per_person": false }
              }
            ]
          }
        ]
      }
    ]
  },
  "description": "Delicious options including: vegetable crudité, brunch grazing board, charcuterie, desserts, and fresh seasonal fruit."
}